import Reveal from './Reveal.jsx';
import Icon from './Icon.jsx';
import { DOCTORS } from '../data/site.js';

export default function Team() {
  return (
    <section id="team" className="team">
      <div className="container">
        <Reveal className="section-header">
          <div className="section-label">Our Team</div>
          <h2 className="section-title">Meet the Faces Behind Your Smile</h2>
          <p className="section-desc">
            Our doctors bring knowledge, care, and a gentle touch to every patient interaction.
          </p>
        </Reveal>

        <div className="team-grid">
          {DOCTORS.map((d, i) => (
            <Reveal className="doctor-card" key={d.name} delay={i * 90}>
              <div className="doctor-photo">
                <Icon name="user" size={52} stroke="rgba(255,255,255,0.88)" width={1.4} />
                <div className="doctor-steth">
                  <Icon name="steth" size={18} stroke="white" width={2} />
                </div>
              </div>
              <div className="doctor-body">
                <div className="doctor-badge">Dentist</div>
                <h3>{d.name}</h3>
                <p className="doctor-qual">{d.qual}</p>
                <p className="doctor-desc">{d.desc}</p>
                <div className="doctor-footer">
                  <Icon name="pin" size={13} width={2} />
                  <span>{d.branch}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="staff-band">
          <div className="staff-emoji">🤝</div>
          <div className="staff-content">
            <h3>Our Dedicated Support Staff</h3>
            <p>
              Behind every great dental visit is a team of caring professionals. Our support staff —
              from dental assistants to front-desk coordinators — work together every day to ensure
              your experience at Kanaga Dental Clinic is smooth, comfortable, and memorable.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
